var _circle, _circle2, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGood(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1334",
    "data-name": "Group 1334",
    xmlns: "http://www.w3.org/2000/svg",
    width: 88.361,
    height: 88.361,
    viewBox: "0 0 88.361 88.361",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_243",
    "data-name": "Ellipse 243",
    cx: 5.771,
    cy: 5.771,
    r: 5.771,
    transform: "matrix(0.217, -0.976, 0.976, 0.217, 23.043, 39.021)",
    fill: "#ffcd3a"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_244",
    "data-name": "Ellipse 244",
    cx: 5.771,
    cy: 5.771,
    r: 5.771,
    transform: "matrix(0.972, -0.234, 0.234, 0.972, 52.957, 30.389)",
    fill: "#ffcd3a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4141",
    "data-name": "Path 4141",
    d: "M2304.262,533.19a44.18,44.18,0,1,0,44.18,44.18A44.231,44.231,0,0,0,2304.262,533.19Zm0,83.406a39.225,39.225,0,1,1,39.225-39.226A39.27,39.27,0,0,1,2304.262,616.6Z",
    transform: "translate(-2260.08 -533.19)",
    fill: "#ffcd3a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4142",
    "data-name": "Path 4142",
    d: "M2445.7,893.71h-41.968a2.478,2.478,0,1,0,0,4.955H2445.7a2.478,2.478,0,0,0,0-4.955Z",
    transform: "translate(-2380.531 -840.796)",
    fill: "#ffcd3a"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGood);
export default __webpack_public_path__ + "static/media/Good.4a56996bdab6d6343a67cb25bc6c0f40.svg";
export { ForwardRef as ReactComponent };